//File Generated by Castle.
//!IMPORTANT Manual Changes to this file will be overwritten

import React, { Component } from 'react';
import {
    TextField,
    IconButton,
    Button,
    ButtonBase,
    FormControlLabel,
    Radio,
    MenuItem,
    Link,
    DatePicker,
    FormControl,
    FormLabel,
    RadioGroup,
    CheckBox
} from '@mui/material';

export default function SecondaryButton ({
  onClick,
  children,
  ...props
}) {
return (
  <IconButton
    {...props}
    sx={{
      backgroundColor: "rgba(255,255,255,0.1)",
      minWidth: 48,
      minHeight: 48,
      '&:hover': {
        backgroundColor: "rgba(255,255,255,0.1)",
      }
    }}
    onClick={onClick}
  >
    {children}
  </IconButton>
)};
